export class DashboardUtils {
  constructor() {}

  static getAverageConsumption(
    dataSet: any[],
    fieldName?: string,
    property?: string
  ): any[] {
    const series: any[] = [];

    if (dataSet && dataSet.length) {
      dataSet.forEach((item) => {
        if (property === undefined) {
          if (item[fieldName] !== undefined && item[fieldName] !== null) {
            let serie = {
              name: item?.vehicle?.licensePlate,
              label: item?.vehicle?.description,
              order: null,
              value: item[fieldName],
              legend: item?.vehicle?.licensePlate,
              fuelType: item?.productGroup?.description,
            };
            series.push(serie);
          }
        } else {
          let serie = {
            name: item?.vehicle?.licensePlate,
            label: item?.vehicle?.description,
            order: null,
            value: item[fieldName]?.[property],
            legend: item?.vehicle?.licensePlate,
            fuelType: item?.productGroup?.description,
          };
          series.push(serie);
        }
      });
    }
    return series;
  }
  static getTransactions(dataSet: any[], fieldName?: string): any[] {
    const series: any[] = [];

    if (dataSet && dataSet.length) {
      dataSet.forEach((item) => {
        if (item[fieldName] !== undefined && item[fieldName] !== null) {
          let serie = {
            name: item?.productGroup?.code,
            label: item?.productGroup?.description,
            order: null,
            value: item[fieldName],
            legend: item?.productGroup?.code,
          };
          series.push(serie);
        }
      });
    }

    return series;
  }

  static getOdometer(
    dataSet: any[],
    fieldName?: string,
    property?: string,
    fieldValue?: string
  ): any[] {
    const series: any[] = [];
    if (dataSet && dataSet.length) {
      dataSet.forEach((item) => {
        if (property === undefined) {
          if (item[fieldName] !== undefined && item[fieldName] !== null) {
            let serie = {
              name: item?.vehicle?.licensePlate,
              label: item?.vehicle?.description,
              order: null,
              value: item[fieldName],
              legend: item?.vehicle?.licensePlate,
              fuelType: item?.productGroup?.description,
            };
            series.push(serie);
          }
        } else {
          let serie = {
            name: item?.vehicle?.licensePlate,
            label: item?.vehicle?.description,
            order: null,
            value: item[fieldName]?.[property],
            legend: item?.vehicle?.licensePlate,
            fuelType: item?.productGroup?.description,
          };
          series.push(serie);
        }
      });
    }
    return series;
  }

  static getFueledVolume(
    dataSet: any[],
    fieldName?: string,
    property?: string
  ): any[] {
    const series: any[] = [];

    if (dataSet && dataSet.length) {
      dataSet.forEach((item) => {
        if (property === undefined) {
          if (item[fieldName] !== undefined && item[fieldName] !== null) {
            let serie = {
              name: item?.vehicle?.licensePlate,
              label: item?.vehicle?.description,
              order: null,
              value: item[fieldName],
              legend: item?.vehicle?.licensePlate,
              fuelType: item?.productGroup?.description,
            };
            series.push(serie);
          }
        } else {
          let serie = {
            name: item?.vehicle?.licensePlate,
            label: item?.vehicle?.description,
            order: null,
            value: item[fieldName]?.[property],
            legend: item?.vehicle?.licensePlate,
            fuelType: item?.productGroup?.description,
          };
          series.push(serie);
        }
      });
    }

    return series;
  }

  //TODO FOR PIECHARTS for product and fuel
  static productGroupPieChartMetrics(
    metrics: any[],
    fieldName?: string,
    property?: string
  ): boolean {
    return true;
  }
  static averagesPieChartMetrics(metrics: any[], field?: any): boolean {
    if (field?.code === "deviation") {
      return false;
    }
    if (field?.code === "percentageDeviation") {
      return false;
    }

    return true;
  }

  static getTopResult(dataSet: any[], topCode: any): any[] {
    switch (topCode?.code) {
      case "Top3":
        dataSet = dataSet.slice(0, 3);
        break;
      case "Top5":
        dataSet = dataSet.slice(0, 5);
        break;
      case "Top7":
        dataSet = dataSet.slice(0, 7);
        break;
      case "Top10":
        dataSet = dataSet.slice(0, 10);
        break;
      case "all":
        break;
    }
    return dataSet;
  }
}
